export default "__VITE_ASSET__iTF$mC$v__"